/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { deviceGroupControllerAddDevices } from '../fn/device-group/device-group-controller-add-devices';
import { DeviceGroupControllerAddDevices$Params } from '../fn/device-group/device-group-controller-add-devices';
import { deviceGroupControllerApplyContent } from '../fn/device-group/device-group-controller-apply-content';
import { DeviceGroupControllerApplyContent$Params } from '../fn/device-group/device-group-controller-apply-content';
import { deviceGroupControllerCreate } from '../fn/device-group/device-group-controller-create';
import { DeviceGroupControllerCreate$Params } from '../fn/device-group/device-group-controller-create';
import { deviceGroupControllerDelete } from '../fn/device-group/device-group-controller-delete';
import { DeviceGroupControllerDelete$Params } from '../fn/device-group/device-group-controller-delete';
import { deviceGroupControllerFindAllByClientId } from '../fn/device-group/device-group-controller-find-all-by-client-id';
import { DeviceGroupControllerFindAllByClientId$Params } from '../fn/device-group/device-group-controller-find-all-by-client-id';
import { deviceGroupControllerFindById } from '../fn/device-group/device-group-controller-find-by-id';
import { DeviceGroupControllerFindById$Params } from '../fn/device-group/device-group-controller-find-by-id';
import { deviceGroupControllerReorderDevices } from '../fn/device-group/device-group-controller-reorder-devices';
import { DeviceGroupControllerReorderDevices$Params } from '../fn/device-group/device-group-controller-reorder-devices';
import { deviceGroupControllerUpdate } from '../fn/device-group/device-group-controller-update';
import { DeviceGroupControllerUpdate$Params } from '../fn/device-group/device-group-controller-update';
import { DeviceGroupDto } from '../models/device-group-dto';

@Injectable({ providedIn: 'root' })
export class DeviceGroupService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `deviceGroupControllerFindAllByClientId()` */
  static readonly DeviceGroupControllerFindAllByClientIdPath = '/api/device-group/all/{clientWorkspaceId}';

  /**
   * 고객사 기반 기기 그룹 전체 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deviceGroupControllerFindAllByClientId()` instead.
   *
   * This method doesn't expect any request body.
   */
  deviceGroupControllerFindAllByClientId$Response(params: DeviceGroupControllerFindAllByClientId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DeviceGroupDto>>> {
    return deviceGroupControllerFindAllByClientId(this.http, this.rootUrl, params, context);
  }

  /**
   * 고객사 기반 기기 그룹 전체 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deviceGroupControllerFindAllByClientId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deviceGroupControllerFindAllByClientId(params: DeviceGroupControllerFindAllByClientId$Params, context?: HttpContext): Observable<Array<DeviceGroupDto>> {
    return this.deviceGroupControllerFindAllByClientId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<DeviceGroupDto>>): Array<DeviceGroupDto> => r.body)
    );
  }

  /** Path part for operation `deviceGroupControllerFindById()` */
  static readonly DeviceGroupControllerFindByIdPath = '/api/device-group/{id}';

  /**
   * 기기 그룹 상세 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deviceGroupControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deviceGroupControllerFindById$Response(params: DeviceGroupControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<DeviceGroupDto>> {
    return deviceGroupControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 기기 그룹 상세 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deviceGroupControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deviceGroupControllerFindById(params: DeviceGroupControllerFindById$Params, context?: HttpContext): Observable<DeviceGroupDto> {
    return this.deviceGroupControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeviceGroupDto>): DeviceGroupDto => r.body)
    );
  }

  /** Path part for operation `deviceGroupControllerCreate()` */
  static readonly DeviceGroupControllerCreatePath = '/api/device-group/{clientWorkspaceId}';

  /**
   * 기기 그룹 생성.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deviceGroupControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deviceGroupControllerCreate$Response(params: DeviceGroupControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<DeviceGroupDto>> {
    return deviceGroupControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 기기 그룹 생성.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deviceGroupControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deviceGroupControllerCreate(params: DeviceGroupControllerCreate$Params, context?: HttpContext): Observable<DeviceGroupDto> {
    return this.deviceGroupControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeviceGroupDto>): DeviceGroupDto => r.body)
    );
  }

  /** Path part for operation `deviceGroupControllerAddDevices()` */
  static readonly DeviceGroupControllerAddDevicesPath = '/api/device-group/{clientWorkspaceId}/{id}/devices';

  /**
   * 기기 그룹에 기기 추가.
   *
   * 기존 그룹에 새로운 기기들을 추가합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deviceGroupControllerAddDevices()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deviceGroupControllerAddDevices$Response(params: DeviceGroupControllerAddDevices$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deviceGroupControllerAddDevices(this.http, this.rootUrl, params, context);
  }

  /**
   * 기기 그룹에 기기 추가.
   *
   * 기존 그룹에 새로운 기기들을 추가합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deviceGroupControllerAddDevices$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deviceGroupControllerAddDevices(params: DeviceGroupControllerAddDevices$Params, context?: HttpContext): Observable<void> {
    return this.deviceGroupControllerAddDevices$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deviceGroupControllerDelete()` */
  static readonly DeviceGroupControllerDeletePath = '/api/device-group/{clientWorkspaceId}/{id}';

  /**
   * 기기 그룹 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deviceGroupControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  deviceGroupControllerDelete$Response(params: DeviceGroupControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeviceGroupDto>> {
    return deviceGroupControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 기기 그룹 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deviceGroupControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deviceGroupControllerDelete(params: DeviceGroupControllerDelete$Params, context?: HttpContext): Observable<DeviceGroupDto> {
    return this.deviceGroupControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeviceGroupDto>): DeviceGroupDto => r.body)
    );
  }

  /** Path part for operation `deviceGroupControllerUpdate()` */
  static readonly DeviceGroupControllerUpdatePath = '/api/device-group/{clientWorkspaceId}/{id}';

  /**
   * 기기 그룹 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deviceGroupControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deviceGroupControllerUpdate$Response(params: DeviceGroupControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<DeviceGroupDto>> {
    return deviceGroupControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 기기 그룹 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deviceGroupControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deviceGroupControllerUpdate(params: DeviceGroupControllerUpdate$Params, context?: HttpContext): Observable<DeviceGroupDto> {
    return this.deviceGroupControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeviceGroupDto>): DeviceGroupDto => r.body)
    );
  }

  /** Path part for operation `deviceGroupControllerApplyContent()` */
  static readonly DeviceGroupControllerApplyContentPath = '/api/device-group/{clientWorkspaceId}/{id}/content';

  /**
   * 그룹 콘텐츠 일괄 적용.
   *
   * 그룹 소속 전체 기기에 콘텐츠 설정/스케줄을 일괄 적용합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deviceGroupControllerApplyContent()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deviceGroupControllerApplyContent$Response(params: DeviceGroupControllerApplyContent$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deviceGroupControllerApplyContent(this.http, this.rootUrl, params, context);
  }

  /**
   * 그룹 콘텐츠 일괄 적용.
   *
   * 그룹 소속 전체 기기에 콘텐츠 설정/스케줄을 일괄 적용합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deviceGroupControllerApplyContent$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deviceGroupControllerApplyContent(params: DeviceGroupControllerApplyContent$Params, context?: HttpContext): Observable<void> {
    return this.deviceGroupControllerApplyContent$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deviceGroupControllerReorderDevices()` */
  static readonly DeviceGroupControllerReorderDevicesPath = '/api/device-group/{clientWorkspaceId}/{id}/reorder';

  /**
   * 그룹 내 기기 순서 변경.
   *
   * 그룹 소속 기기의 표시 순서를 변경합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deviceGroupControllerReorderDevices()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deviceGroupControllerReorderDevices$Response(params: DeviceGroupControllerReorderDevices$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deviceGroupControllerReorderDevices(this.http, this.rootUrl, params, context);
  }

  /**
   * 그룹 내 기기 순서 변경.
   *
   * 그룹 소속 기기의 표시 순서를 변경합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deviceGroupControllerReorderDevices$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deviceGroupControllerReorderDevices(params: DeviceGroupControllerReorderDevices$Params, context?: HttpContext): Observable<void> {
    return this.deviceGroupControllerReorderDevices$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
